import { Link } from 'react-router-dom';
import { ProfileSidebarItemProps } from './ProfileSidebarItem.types';

export default ({
  icon: Icon,
  label,
  isActive,
  isCompany,
  to,
  ...props
}: ProfileSidebarItemProps) => {
  return (
    <Link to={to}>
      <div
        className={`profile__sidebar-list-item${
          isActive ? ' profile__sidebar-list-item--active' : ''
        }${isCompany ? ' profile__sidebar-list-item--secondary' : ''}`}
        {...props}>
        <Icon />
        <label>{label}</label>
      </div>
    </Link>
  );
};
